import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702b82dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "SlotHolder",
  ref: "slot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "FakeScroll",
      ref: "slot_fake",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScrollFake && _ctx.onScrollFake(...args)))
    }, [
      (_ctx.state.fake_width)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(`width: ${_ctx.state.fake_width}px`)
          }, null, 4))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", {
      class: "TableScrollWrapper",
      ref: "slot_holder",
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 512)
    ], 544)
  ], 64))
}